"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOpener = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var MenuOpenedByClick_1 = require("./MenuOpenedByClick");
var MenuOpenedByHover_1 = require("./MenuOpenedByHover");
var MenuOpener = /** @class */ (function (_super) {
    tslib_1.__extends(MenuOpener, _super);
    function MenuOpener() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getComponentByOpenAction = function () {
            switch (_this.props.openAction) {
                case "click":
                    return MenuOpenedByClick_1.MenuOpenedByClick;
                case "hover":
                    return MenuOpenedByHover_1.MenuOpenedByHover;
            }
        };
        return _this;
    }
    MenuOpener.prototype.render = function () {
        var Component = this.getComponentByOpenAction();
        return (react_1.default.createElement(Component, { opened: this.props.opened, onOpenedChange: this.props.onOpenedChange, topLevelMenu: this.props.topLevelMenu, alignment: this.props.alignment, spacing: this.props.spacing, offset: this.props.offset, toggler: this.props.toggler, togglerWrapperClassName: this.props.togglerWrapperClassName, portalTarget: this.props.portalTarget },
            react_1.default.createElement("div", { className: "gd-menuOpener" }, this.props.children)));
    };
    MenuOpener.defaultProps = {
        openAction: "hover",
        alignment: ["right", "bottom"],
        spacing: 0,
        offset: 0,
        portalTarget: document.querySelector("body"),
    };
    return MenuOpener;
}(react_1.default.Component));
exports.MenuOpener = MenuOpener;
//# sourceMappingURL=MenuOpener.js.map